module.exports = __webpack_public_path__ + "img/logo.4433b36c.svg";